import type { PropsWithChildren } from "react";

import { getSpaceVariable } from "../space/utilities";
import { WithSpace } from "../space/WithSpace";

type MenuProps = PropsWithChildren;

export default function Menu(props: MenuProps) {
    const { children } = props;
    return (
        <WithSpace horizontal={2}>
            <div css={{ display: "flex", flexDirection: "column", gap: getSpaceVariable(2) }}>
                {children}
            </div>
        </WithSpace>
    );
}
